const AuthActionTypes = {
  SET_USER_AUTH: "SET_USER_AUTH",
};

export default AuthActionTypes;
